<!--
  @description v2.0.3 流程管理-主机与数据库权限
  @author xiehan
  @date 2019/03/08
-->
<template>
  <div class="dbPermissionOrder">
    <request-note
      ref="requestNote"
      @submitRequest="getRequestForm"
      submitButtonRac="dbPermissionOrder@submit"
      :requestTitle="$t('cloudApplication.dbPermissionRequest')"
      :assignee="assignee"
      :status="status"
      :requestInfo="requestInfo">
      <div slot="center">
        <!-- 被赋权人 -->
        <el-form ref="permissionForm" :model="permissionForm" :inline="true" input-width="auto">
          <el-form-item :label="$t('cloudApplication.empowerment')" prop="grantId">
            <span v-text="permissionForm.grantId"></span>
          </el-form-item>
          <el-form-item :label="$t('cloudApplication.grantDepartment')" prop="grantDepartment">
            <span v-text="permissionForm.grantDepartment"></span>
          </el-form-item>
        </el-form>
        <!-- 仓库 -->
        <div v-show="resourceList.length > 0">
          <label class="el-form-item__label center__label" v-text="$t('envauthority.repertory')"></label>
          <div class="mt-base resource-table__wrap" v-for="(resourceItem, index) in resourceList" :key="resourceItem.flagId + index">
            <div v-text="select_resource[resourceItem.flagId]"></div>
            <table class="mt-base">
              <thead>
                <tr>
                  <th class="t-border" v-text="$t('envauthority.authority')"></th>
                  <th class="t-border" 
                    v-for="(item, index) in resourceItem.parton" 
                    :key="index"
                    v-text="item"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in resourceItem.data" :key="item.id">
                  <td class="t-border">{{ item.auth | auth }}</td>
                  <td class="t-border" 
                    v-for="(_item, index) in resourceItem.parton"
                    :key="index"
                    v-text="item[index]"
                    :title="item[index]"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 机器 -->
        <div v-show="machinesList.length > 0">
          <label class="el-form-item__label center__label" v-text="$t('envauthority.machine')"></label>
          <div class="mt-base" style="margin-left: 70px; padding-top: 12px;">
            <table>
                <thead>
                  <tr>
                    <th class="t-border" v-text="$t('envauthority.authority')"></th>
                    <th class="t-border" v-text="'IP'"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in machinesList" :key="item.ip">
                    <td class="t-border">{{ item.auth | auth }}</td>
                    <td class="t-border" v-text="item.ip"></td>
                  </tr>
                </tbody>
            </table>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-form label-width="80px" v-if="!assignee && (status !== '6' && status !== '5')">
          <el-form-item :label="$t('cloudApplication.currentAssignee')">
            <span v-text="requestInfo.currentAssignee"></span>
          </el-form-item>
        </el-form>
        <el-table
          v-if="!assignee"
          :data="processTable"
          style="width: 100%">
          <el-table-column prop="operateTime" :label="$t('common.time')"></el-table-column>
          <el-table-column prop="node" :label="$t('queryworkOrder.node')"></el-table-column>
          <el-table-column prop="operator" :label="$t('queryworkOrder.operator')"></el-table-column>
          <el-table-column prop="operation" :label="$t('common.handle')"></el-table-column>
          <el-table-column prop="advise" :label="$t('queryworkOrder.advise')"></el-table-column>
        </el-table>
      </div>
    </request-note>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import requestNote from '@/views/component/requestNote/requestNote'
  import resourceModelBiz from '@/logic/cmdb/resourceModelBiz'
  import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
  import TimeFormat from '@/utils/timeFormat'
  let vm
  export default {
    mixins: [dic],
    data () {
      vm = this
      return {
        status: '',
        select_site: {},
        select_operate: {},
        select_resource: {},
        requestInfo: {},
        permissionForm: {
          grantId: '',
          grantDepartment: ''
        },
        assignee: true,
        processTable: [],
        resourceList: [],
        machinesList: []
      }
    },
    components: {
      requestNote
    },
    methods: {
      init () {
        this.status = String(this.$route.query.status)
        this.assignee = String(this.$route.query.assignee) === '1'
        this.getDic()
        this.getResourceDic()
      },
      getResourceDic () {
        return resourceModelBiz.getResource().then((data) => {
          let obj = {}
          data.map((item) => {
            if (item.resourceType === '3') {
              obj[item.flagId] = item.resourceName
            }
          })
          this.select_resource = { ...obj }
        })
      },
      setResourceList (repository) {
        let resourceList = []
        if (repository && repository.length > 0) {
          repository.map(item => {
            let parton = {}
            item.properties.map(_item => {
              if (_item.display) {
                parton[_item['property']] = _item['name']
              }
            })
            resourceList.push({
              flagId: item.flagId,
              data: item.authList,
              parton: parton
            })
          })
        }
        this.resourceList = resourceList
      },
      getOrderInfoById () {
        queryworkOrderBiz.getTaskDetailById({
          processInstanceId: String(this.$route.query.orderId)
        }).then(data => {
          this.requestInfo = data.info
          this.permissionForm = this.requestInfo.userInfos[0]
          this.requestInfo.site = this.select_site[this.requestInfo.site]
          this.requestInfo.date = TimeFormat.getFormatTime(this.requestInfo.date)
          this.requestInfo.expectedTime = TimeFormat.getFormatTime(this.requestInfo.expectedTime)
          this.processTable = data.record
          this.setResourceList(data.info.repository)
          this.machinesList = data.info.host
          this.processTable.map(item => {
            item.operateTime = TimeFormat.getFormatTime(item.operateTime)
            item.operation = this.select_operate[item.operation]
          })
        })
      },
      async getDic () {
        await Promise.all([
          this.dGetDictionaryByCode('remoteconfig'),
          this.dGetDictionaryByCode('workflowOperationType')
        ])
        this.select_site = { ...this.dDictionary.remoteconfig }
        this.select_operate = { ...this.dDictionary.workflowOperationType }
        this.getOrderInfoById()
      },
      getRequestForm (val) {
        let eventName
        let param = {}
        if (this.$route.query.status === '2') {
          eventName = 'permissionApproveApply'
          param = { ...val }
        } else if (this.$route.query.status === '3') {
          eventName = 'permissionExecute'
        }
        queryworkOrderBiz[eventName]({
          processInstanceId: this.$route.query.orderId, ...param
        }).then(data => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.$router.push({ name: 'queryworkOrder' })
        })
      }
    },
    filters: {
      auth (value) {
        let lan = ''
        if (value.length === 1 && value[0] === '1') {
          lan = vm.$t('envauthority.onlyRead')
        } else if (value.length === 1 && value[0] === '2') {
          lan = vm.$t('envauthority.onlyWrite')
        } else {
          lan = `${vm.$t('envauthority.onlyRead')}、${vm.$t('envauthority.onlyWrite')}`
        }
        return lan
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'dbPermissionOrder' && from.name === 'queryworkOrder') {
          if (this.status === '5') {
            this.$nextTick(() => {
              this.$refs.requestNote.onStatus5()
            })
          } else {
            this.$refs.requestNote.init()
          }
          this.init()
        }
      }
    },
    mounted () {
      this.init()
      if (this.status === '5') {
        this.$nextTick(() => {
          this.$refs.requestNote.onStatus5()
        })
      }
    }
  }
</script>

<style scoped>
  .resource-table__wrap {
    overflow-x: scroll;
    margin-left: 70px;
    padding-top: 12px;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  .t-border {
    height: 30px;
    width: 110px;
    min-width: 84px;
    max-width: 150px;
    padding: 0 4px;
    border: 1px solid #ddd;
    text-align: center;
    font-weight: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>